import { EGender, EStatus, IClinicalInfo, IPedigreeEthnicity, IPedigreeGraphNode, ISurgery } from './PedigreeService';

export default class PedigreeNode implements Partial<IPedigreeGraphNode> {
  public id!: number;

  public name!: string;

  public birthDate?: string;

  public lmp?: string;

  public gender?: EGender;

  public status = EStatus.NORMAL;

  public isProband = false;

  public clinicalInfos: IClinicalInfo[] = [];

  public surgeries: ISurgery[] = [];

  public ethnicities?: IPedigreeEthnicity[] = [];

  public origin!: Element;

  /**
   * Contains runtime-only mapping data.
   */
  public metadata!: any;

  public setId(id: number) {
    this.id = id;

    return this;
  }

  public setName(name: string) {
    this.name = name;

    return this;
  }

  public setBirthDate(birthDate: string) {
    this.birthDate = birthDate;

    return this;
  }

  public setLmp(lmpDate: string) {
    this.lmp = lmpDate;

    return this;
  }

  setRelationType(relationType: string) {
    this.metadata = {
      ...this.metadata,
      relationType,
    };

    return this;
  }

  public setGender(gender: EGender | undefined) {
    this.gender = gender?.toUpperCase() as EGender;

    return this;
  }

  public setOrigin(origin: Element) {
    this.origin = origin;

    return this;
  }

  public setStatus(status: EStatus) {
    this.status = status;

    return this;
  }

  public makeProband(isProband = true) {
    this.isProband = isProband;

    return this;
  }

  public setEthnicities(ethnicities: string) {
    this.ethnicities = JSON.parse(ethnicities);

    return this;
  }

  public setClinicalInfos(clinicalInfos: string) {
    this.clinicalInfos = Object.values(JSON.parse(clinicalInfos));

    return this;
  }

  public setSurgeries(surgeries: string) {
    this.surgeries = Object.values(JSON.parse(surgeries));

    return this;
  }
}
